<template>
    <a class="product-badge" :href="product.url" target="_blank" @click="logNavigatedTo(product.name)">
        <slot />
    </a>
</template>

<script setup>
const props = defineProps({
    product: {
        type: Object,
        required: true,
    },
});
import { useAnalytics } from '../composables/useAnalytics';

const { logNavigatedTo } = useAnalytics();
</script>

<style lang="scss" scoped>
@use 'ihunter-pathfinder/styles' as Pathfinder;

.product-badge {
    @include Pathfinder.ProductBadgeSizing;
}
</style>
